import { render, staticRenderFns } from "./ConfirmCaptainDialog.vue?vue&type=template&id=52dd8638"
import script from "./ConfirmCaptainDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmCaptainDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports